import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Issuef8rh7nn7wz0o as Issue } from './IssueNode.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  InternalReactiveNotActive2613wuivyis0b as InternalReactiveNotActive,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  ReactiveStatel8ixobo86msn as ReactiveState,
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
} from '../../core/ReactiveState.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { BaseListenable1u3g4s45l82o6 as BaseListenable } from '../../core/abstracts.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../../core/signals.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../core/Remember.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  addAndRunListener8g331b1wn43q as addAndRunListener,
  Reactive1jy75v4li6ldv as Reactive,
} from '../../core/coreInterfaces.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  lensi9s8q1zaykbw as lens,
  lens2dr2mfn274h1a as lens_0,
  MutableValidated2ognu5vxf17ur as MutableValidated,
} from './Validated.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function assertReactive(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  var tmp = !setOnIssue;
  return auditReactive(_this__u8e3s4, tmp, ($this$auditReactive, value) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (condition($this$auditReactive, value)) {
      tmp = null;
    } else {
      tmp = new (Issue())(summary, description, setOnIssue);
    }
    return tmp;
  });
}
function auditReactive(_this__u8e3s4, checkForSetOnIssue, validate) {
  checkForSetOnIssue = checkForSetOnIssue === VOID ? true : checkForSetOnIssue;
  var auditor = Auditor().new_com_lightningkite_reactive_lensing_validation_Auditor_yu350o_k$(_this__u8e3s4, checkForSetOnIssue, validate);
  return new (auditReactive$1())(auditor, checkForSetOnIssue, _this__u8e3s4);
}
function emit($this, state) {
  if ($this.willUseCheck_1) {
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.onSuccess' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
    var this_0 = $this.emit_1.get_state_wc71uu_k$();
    var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
    var tmp;
    if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
      tmp = null;
    } else {
      if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
        tmp = null;
      } else {
        if (tmp0_subject instanceof InternalReactiveThrownException()) {
          _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
          tmp = null;
        } else {
          if (tmp0_subject instanceof InternalReactiveWrapper()) {
            // Inline function 'com.lightningkite.reactive.lensing.validation.Auditor.terminate' call
            var this_1 = _ReactiveState___get_raw__impl__92ipya(this_0).other_1.second_1;
            if (!(this_1 == null) && this_1.get_isActive_quafmh_k$()) {
              this_1.cancel$default_vwdpyq_k$();
            }
            tmp = Unit_instance;
          } else {
            // Inline function 'com.lightningkite.reactive.lensing.validation.Auditor.terminate' call
            var this_2 = _ReactiveState___get_raw__impl__92ipya(this_0).second_1;
            if (!(this_2 == null) && this_2.get_isActive_quafmh_k$()) {
              this_2.cancel$default_vwdpyq_k$();
            }
            tmp = Unit_instance;
          }
        }
      }
    }
  }
  $this.emit_1.set_state_wnfcx0_k$(state);
}
var AuditorClass;
function Auditor() {
  if (AuditorClass === VOID) {
    class $ extends BaseListenable() {
      constructor(source, willUseCheck, validate) {
        return new.target.new_com_lightningkite_reactive_lensing_validation_Auditor_yu350o_k$(source, willUseCheck, validate);
      }
      static new_com_lightningkite_reactive_lensing_validation_Auditor_yu350o_k$(source, willUseCheck, validate) {
        var $this = this.new_com_lightningkite_reactive_core_BaseListenable_e3suws_k$();
        $this.source_1 = source;
        $this.willUseCheck_1 = willUseCheck;
        $this.validate_1 = validate;
        $this.node_1 = $this.source_1.get_node_wor8sr_k$().child_v2u7ef_k$(false);
        $this.emit_1 = RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$();
        var tmp = $this;
        tmp.process_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var _destruct__k2r9zo = $this$remember.invoke_r7m7el_k$($this.emit_1);
          var value = _destruct__k2r9zo.component1_7eebsc_k$();
          var cont = _destruct__k2r9zo.component2_7eebsb_k$();
          // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
          var result = $this.validate_1($this$remember, value);
          // Inline function 'com.lightningkite.reactive.lensing.validation.Auditor.terminate' call
          if (!(cont == null) && cont.get_isActive_quafmh_k$()) {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$4 = _Result___init__impl__xyqfz8(result);
            cont.resumeWith_rk9gbt_k$(tmp$ret$4);
          }
          return result;
        });
        $this.releaseProcess_1 = null;
        $this.releaseSource_1 = null;
        return $this;
      }
      get_node_wor8sr_k$() {
        return this.node_1;
      }
      get_state_wc71uu_k$() {
        var tmp0 = this.emit_1.get_state_wc71uu_k$();
        var tmp$ret$0;
        $l$block_1: {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
          var tmp;
          var tmp_0;
          var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_1 instanceof InternalReactiveNotReady()) {
            tmp_0 = true;
          } else {
            var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp_0 = tmp_2 instanceof InternalReactiveNotActive();
          }
          if (tmp_0) {
            tmp = true;
          } else {
            var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            tmp = tmp_3 instanceof InternalReactiveThrownException();
          }
          if (tmp) {
            tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
            break $l$block_1;
          }
          var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0);
          if (tmp_4 instanceof InternalReactiveWrapper())
            try {
              var tmp$ret$1 = _ReactiveState___get_raw__impl__92ipya(tmp0).other_1.first_1;
              tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(tmp$ret$1);
              break $l$block_1;
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                tmp$ret$0 = Companion_getInstance().exception_iibuh2_k$(e);
                break $l$block_1;
              } else {
                throw $p;
              }
            }
          var tmp_5;
          try {
            var tmp$ret$2 = _ReactiveState___get_raw__impl__92ipya(tmp0).first_1;
            tmp_5 = _ReactiveState___init__impl__fvdp9b(tmp$ret$2);
          } catch ($p_0) {
            var tmp_6;
            if ($p_0 instanceof Exception()) {
              var e_0 = $p_0;
              tmp_6 = Companion_getInstance().exception_iibuh2_k$(e_0);
            } else {
              throw $p_0;
            }
            tmp_5 = tmp_6;
          }
          tmp$ret$0 = tmp_5;
        }
        return tmp$ret$0;
      }
      activate_yijg9v_k$() {
        this.node_1.connect_ivqcka_k$();
        var tmp = this;
        tmp.releaseSource_1 = addAndRunListener(this.source_1, () => {
          var tmp0 = this.source_1.get_state_wc71uu_k$();
          var tmp$ret$0;
          $l$block_1: {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.map' call
            var tmp;
            var tmp_0;
            var tmp_1 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_1 instanceof InternalReactiveNotReady()) {
              tmp_0 = true;
            } else {
              var tmp_2 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp_0 = tmp_2 instanceof InternalReactiveNotActive();
            }
            if (tmp_0) {
              tmp = true;
            } else {
              var tmp_3 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              tmp = tmp_3 instanceof InternalReactiveThrownException();
            }
            if (tmp) {
              tmp$ret$0 = new (ReactiveState())(tmp0) instanceof ReactiveState() ? tmp0 : THROW_CCE();
              break $l$block_1;
            }
            var tmp_4 = _ReactiveState___get_raw__impl__92ipya(tmp0);
            if (tmp_4 instanceof InternalReactiveWrapper())
              try {
                var it = _ReactiveState___get_raw__impl__92ipya(tmp0).other_1;
                var tmp$ret$1 = to(it, null);
                tmp$ret$0 = _ReactiveState___init__impl__fvdp9b(tmp$ret$1);
                break $l$block_1;
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  tmp$ret$0 = Companion_getInstance().exception_iibuh2_k$(e);
                  break $l$block_1;
                } else {
                  throw $p;
                }
              }
            var tmp_5;
            try {
              var it_0 = _ReactiveState___get_raw__impl__92ipya(tmp0);
              var tmp$ret$2 = to(it_0, null);
              tmp_5 = _ReactiveState___init__impl__fvdp9b(tmp$ret$2);
            } catch ($p_0) {
              var tmp_6;
              if ($p_0 instanceof Exception()) {
                var e_0 = $p_0;
                tmp_6 = Companion_getInstance().exception_iibuh2_k$(e_0);
              } else {
                throw $p_0;
              }
              tmp_5 = tmp_6;
            }
            tmp$ret$0 = tmp_5;
          }
          emit(this, tmp$ret$0);
          this.invokeAllListeners_uusj2y_k$();
          return Unit_instance;
        });
        var tmp_0 = this;
        tmp_0.releaseProcess_1 = addAndRunListener(this.process_1, () => {
          this.node_1.reportRaw_ihpspr_k$(this.process_1.get_state_wc71uu_k$());
          return Unit_instance;
        });
      }
      deactivate_pmdz1g_k$() {
        this.node_1.disconnect_t9cc0c_k$();
        var tmp0_safe_receiver = this.releaseSource_1;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver();
        this.releaseSource_1 = null;
        var tmp1_safe_receiver = this.releaseProcess_1;
        if (tmp1_safe_receiver == null)
          null;
        else
          tmp1_safe_receiver();
        this.releaseProcess_1 = null;
      }
      *check_5qw3tv_k$(value, $completion) {
        // Inline function 'kotlin.require' call
        if (!this.willUseCheck_1) {
          var message = 'Set `willUseCheck = false` and then called `check`';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        var tmp;
        if (this.releaseProcess_1 == null) {
          var release = addAndRunListener(this.process_1, () => {
            this.node_1.reportRaw_ihpspr_k$(this.process_1.get_state_wc71uu_k$());
            return Unit_instance;
          });
          var tmp_0;
          try {
            // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
            // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
            tmp_0 = yield () => {
              var uCont = $completion;
              var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
              cancellable.initCancellability_shqc60_k$();
              emit(this, _ReactiveState___init__impl__fvdp9b(to(value, cancellable)));
              return cancellable.getResult_fck196_k$();
            };
          }finally {
            release();
          }
          tmp = tmp_0;
        } else {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          tmp = yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.initCancellability_shqc60_k$();
            emit(this, _ReactiveState___init__impl__fvdp9b(to(value, cancellable)));
            return cancellable.getResult_fck196_k$();
          };
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'Auditor', VOID, VOID, [Reactive()], [1]);
    AuditorClass = $;
  }
  return AuditorClass;
}
var auditReactive$1Class;
function auditReactive$1() {
  if (auditReactive$1Class === VOID) {
    class $ {
      constructor($auditor, $checkForSetOnIssue, $this_auditReactive) {
        this.$auditor_1 = $auditor;
        this.$checkForSetOnIssue_1 = $checkForSetOnIssue;
        this.$this_auditReactive_1 = $this_auditReactive;
        this.$$delegate_0__1 = $auditor;
      }
      *set_revjhg_k$(value, $completion) {
        if (this.$checkForSetOnIssue_1) {
          var result = yield* this.$auditor_1.check_5qw3tv_k$(value, $completion);
          if ((result == null ? null : result.setValue_1) === false)
            return Unit_instance;
        }
        yield* this.$this_auditReactive_1.set_revjhg_k$(value, $completion);
        return Unit_instance;
      }
      get_node_wor8sr_k$() {
        return this.$$delegate_0__1.node_1;
      }
      get_state_wc71uu_k$() {
        return this.$$delegate_0__1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    protoOf($).lens_drj4fu_k$ = lens;
    protoOf($).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($, VOID, VOID, VOID, [MutableValidated(), Reactive()], [1]);
    auditReactive$1Class = $;
  }
  return auditReactive$1Class;
}
//region block: exports
export {
  assertReactive as assertReactive22ewziiekbth5,
};
//endregion

//# sourceMappingURL=reactiveHelpers.mjs.map
